export default {
    cooperator: [
        {
            img: require('@/assets/images/cooperator/001.png')
        }, {
            img: require('@/assets/images/cooperator/002.png')
        }, {
            img: require('@/assets/images/cooperator/003.png')
        }, {
            img: require('@/assets/images/cooperator/004.png')
        }, {
            img: require('@/assets/images/cooperator/005.png')
        }, {
            img: require('@/assets/images/cooperator/006.png')
        }, {
            img: require('@/assets/images/cooperator/007.png')
        }, {
            img: require('@/assets/images/cooperator/008.png')
        }, {
            img: require('@/assets/images/cooperator/009.png')
        }, {
            img: require('@/assets/images/cooperator/010.png')
        }, {
            img: require('@/assets/images/cooperator/011.png')
        }, {
            img: require('@/assets/images/cooperator/012.png')
        }, {
            img: require('@/assets/images/cooperator/013.png')
        }, {
            img: require('@/assets/images/cooperator/014.png')
        }, {
            img: require('@/assets/images/cooperator/015.png')
        }, {
            img: require('@/assets/images/cooperator/016.png')
        }
    ],
    industryList: [
        {
          name: '生产制造',
          icon: 'iconshengchanzhizao',
          title: '科技助力生产数字化',
          desc: '企业生产智能化解决方案以数据、集成、个性和管控为主线，面向制造、工业企业，尤其是中小型企业，提供创新的公共服务平台。以企业价值增值为核心，打造企业智慧研发、智慧管理、智能生产、智能服务和智能决策系列解决方案。',
          img: require('@/assets/site/industry_manufacturing.jpg')
        }, {
          name: '教育行业',
          icon: 'iconjiaoyu1',
          title: '在线教育一站式解决',
          desc: 'APJ拥有成熟的互联网+教育解决方案，服务于园区、大中院校、教育机构等，建构以人为本、智能协同的智慧校园体系，平台特色：智能化学习、一站式服务、创新的“在线实训”模式。',
          img: require('@/assets/site/industry_education.jpg')
        }, {
          name: '医疗健康',
          icon: 'iconyiliaohangye',
          title: '精准定位，智慧医疗',
          desc: '智慧医疗健康在技术上充分运用了人工智能、云计算、大数据等新一代网络信息技术的优势，把线下服务搬到线上，实现中医药网上咨询、视频问诊、商城服务等，促进线上线下服务联动，打破区域的限制，让病人客户可以在任何地方接受专业的中医诊症服务。',
          img: require('@/assets/site/industry_health.jpg')
        }, {
          name: '轨道交通',
          icon: 'iconguidaojiaotong',
          title: '智能交通，城市更便捷',
          desc: 'APJ近20年的基础和在轨道交通行业丰富的项目应用开发经验上，将物联网、互联网、云计算为代表的智能传感技术、信息网络技术、通信传输技术和数据处理技术等有效地集成，整理形成了一套有效适用于轨道交通的运营管理流程、信息化系统实时监控运营情况及保障运营安全的轨道交通运营信息管理解决方案。',
          img: require('@/assets/site/rail_transit.jpg')
        }, {
          name: '石油化工',
          icon: 'iconshiyouhuagong',
          title: '数字化工，重构产业生态',
          desc: '面向分布式（可再生）能源市场的综合系统解决方案，通过顶层设计及统筹规划，结合互联网及大数据分析技术，从全流程全区域供能、用能、能量转换的角度出发，通过多能互补梯级利用，将可再生、清洁及传统能源高效耦合集成，以智能管控、专业运营模式，按时、按需、按质向用户端提供的分布式清洁能源综合一体化的解决方案。',
          img: require('@/assets/site/industry_petrochemical.jpg')
        }, {
          name: '金融行业',
          icon: 'iconjinronghangye',
          title: '全价值链数字化',
          desc: 'APJ从事金融银行业的测试服务，为相关领域配备专业高效的测试团队，具备丰富的行业测试经验和金融证券等行业业务知识，涵盖证券、银行、外汇行业的IT架构规划、交易、监察、风险管理等方面，可生成不同需求的解决方案，并提供高效可靠的半自动测试流程来支持用户。在保证客户信息安全与知识产权保密的同时，提供从战略咨询，测试过程到用户手册的IT服务，实现客户的效益最大化。',
          img: require('@/assets/site/industry_finance.jpg')
        }, {
          name: '公共事业',
          icon: 'icongonggongshiye',
          title: '让城市美得更细致',
          desc: 'APJ多年来在燃气、水务和路灯等公共事业有着深厚的行业积淀，并且在5G网络、数据中心、人工智能、工业互联网等新型技术的应用下，将过往传统、低效、线下的业务、流程和服务创新地平移到线上，流程优化的基础上，用全新的方法和程序去完成原有的业务功能，实现数字化新基建。',
          img: require('@/assets/site/industry_common.jpg')
        }, {
          name: '零售业',
          icon: 'iconlingshouye',
          title: '全面价值链管理模式',
          desc: 'APJ全渠道零售解决方案以构建中国服装零售行业的最佳管理模式为目标，专门面向服装零售企业设计，提供电子商务时代零售行业企业的标准解决方案和零售行业应用最佳实践。在客户成功应用的基础上，APJ提炼出完整的业务管理模式，帮助零售企业实现全面价值链管理。',
          img: require('@/assets/site/industry_retail.jpg')
        }
    ],
    successCaseList: [
        {
          img: require('@/assets/site/img_tdmall.jpg'),
          title: '云上天大馆',
          subTitle: '人人可及的优质中医药服务',
          desc: '云上天大馆是通过IT技术，把线下服务搬到线上，实现中医药网上咨询、视频问诊、商城服务等，促进线上线下服务联动，打破区域的限制，让病人客户可以在任何地方接受专业的中医诊症服务。'
        }, {
          img: require('@/assets/site/img_shaangu.jpg'),
          title: '陕鼓能源管理系统',
          subTitle: '多元化智慧绿色能源',
          desc: '能源数据管理系统是实现能源数据的采集，监控，统计分析并为企业内各个部门提供能源数据服务，为用户提供各种能耗指标。该系统具有良好的扩展性，长期运行的稳定性和能源数据存取的高效性。'
        }, {
          img: require('@/assets/site/img_gas.jpg'),
          title: '智慧燃气',
          subTitle: '提升管理效率和服务水平',
          desc: '智慧燃气是基于GIS的燃气管网信息系统，利用物联网、移动智能终端等技术手段，以提升管理效率和服务水平，为燃气企业带来了良好的经济效益和社会效益。'
        }, {
          img: require('@/assets/images/index/zhihuiyanglao.png'),
          title: '智慧养老院管理平台',
          subTitle: '全方位的智慧养老服务',
          desc: '智慧养老院管理平台针对养老院管理,集高级护理、医疗、个人照顾、院舍管理、系统管理等管理组件为一体，将各职能部门、服务单元以及外部市场连成一个有机整体，为养老院机构的管理和服务提供适时、准确、可靠的决策依据，提高经营管理效能。'
          // desc: '明心养老院管理平台针对养老院管理,集高级护理、医疗、个人照顾、院舍管理、系统管理等管理组件为一体，将各职能部门、服务单元以及外部市场连成一个有机整体，进行快速、高效的资讯收集和业务处理，为养老院机构的管理和服务提供适时、准确、可靠的决策依据，提高经营管理效能，增强养老院机构核心竞争力。'
        }, {
          img: require('@/assets/images/index/sxb-edu.png'),
          title: '实训邦云课堂',
          subTitle: '在线教育一站式解决方案',
          desc: '实训邦云课堂专注于为教培机构、知识付费、企业内训行业提供一站式解决方案。通过高效的SaaS模式，集合了图文、音频、视频、电子书、直播等主流内容形态，帮助客户轻松开启线上教育服务。'
          // desc: '实训邦云课堂专注于为教培机构、知识付费、企业内训行业提供一站式解决方案。方案通过高效的SaaS模式，集合了图文、音频、视频、电子书、直播等主流内容形态，提供简单易用的教务/培训管理系统、还原线下教学的互动直播课堂、智能高效的排课系统、完善有序的企业内训体系和专注教育行业的招生引流工具，让内容的生产发布、推广分发、管理交互、交易收入变得更加简单，帮助客户轻松开启线上教育服务。'
        }
    ],
    newsList: [
        {
          title: '喜讯 | APJ云课堂斩获华为鲲鹏应用开发者大赛三等奖...',
          subTitle: '4月12日，由华为和华发集团联合主办的“鲲鹏入珠·向海而兴”珠海首届鲲鹏训练营暨鲲鹏应用开发者大赛在珠海国际会议中心落下帷幕。APJ团队在50支参赛队伍中脱颖而出',
          publishDate: '04.12',
          image: require("@/assets/images/news/10.png")
        },
        {
          title: '简讯 | 广东省科协、珠海市科协领导莅临APJ调研座谈...',
          subTitle: '4月9日上午，广东省科协党组成员、专职副主席范英妍，广东省科协学会学术部部长、省',
          publishDate: '04.09',
          image: require("@/assets/images/news/img010.jpg")
        },
        {
          title: '清华科技园新办公区举行了简单而隆重的新办公区启用庆典...',
          subTitle: 'APJ新办公区启用庆典 续写新篇章”',
          publishDate: '03.10',
          image: require('@/assets/site/news_img_1.jpg')
        },
        {
          title: 'APJ再获广东省科学技术厅"优秀省级工程技术...',
          subTitle: 'APJ再次被评为。 优秀省级工程技术研究中心”单位',
          publishDate: '03.06',
          image: require('@/assets/site/news_2.jpg')
        }
        // {
        //   title: 'APJ做客微信圆桌论坛，共话数字化驱动下的...',
        //   subTitle: '传统型企业如何在互联网时代把握机遇实现突破?',
        //   publishDate: '02.25',
        //   image: require('@/assets/site/news_img_3.jpg')
        // },
        // {
        //   title: 'APJ携企业数字化解决方案亮相2020陕西国际...',
        //   subTitle: '2020陕西国际科技创新创业博览会在西安国际会展中心圆满落幕',
        //   publishDate: '02.17',
        //   image: require('@/assets/site/news_img_4.jpg')
        // }
    ]
}



// WEBPACK FOOTER //
// ./src/views/index/data.js